export function useCookie(key: string) {
  function get(): string | null {
    const escapedKey = key.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1");
    const match = document.cookie.match(new RegExp("(?:^|; )" + escapedKey + "=([^;]*)"));
    return match ? match[1] : null;
  }

  function save(value: string): void {
    const attributes = ["path=/", "SameSite=Lax"];
    if (location.protocol === "https:") {
      attributes.push("Secure");
    }
    document.cookie = `${key}=${value}; ${attributes.join("; ")}`;
  }

  function remove(): void {
    const attributes = ["path=/", "expires=Thu, 01 Jan 1970 00:00:00 GMT"];
    if (location.protocol === "https:") {
      attributes.push("Secure");
    }
    document.cookie = `${key}=; ${attributes.join("; ")}`;
  }

  return { get, save, remove };
}
